import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Form,
  Modal,
} from "react-bootstrap";
import { FaPlus, FaTrash, FaEdit } from "react-icons/fa";
import "./CustomerList.css";
import axios from "axios";

// const formatTo12Hour = (time24) => {
//   if (!time24) return "";
//   const [hhStr, mm] = time24.split(":");
//   let hh = Number(hhStr);
//   const ampm = hh >= 12 ? "PM" : "AM";
//   hh = hh % 12;
//   if (hh === 0) hh = 12;
//   const hhPadded = hh.toString().padStart(2, "0");
//   return `${hhPadded}:${mm} ${ampm}`;
// };

const WorkingHours = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [show, setShow] = useState(false);
  const [designations, setDesignations] = useState([]);
  const [workingHrsList, setWorkingHrsList] = useState([]);

  // Convert 24-hour time to 12-hour format with AM/PM
  const formatTo12Hour = (time24) => {
    if (!time24) return "";
    const [hhStr, mm] = time24.split(":");
    let hh = Number(hhStr);
    const ampm = hh >= 12 ? "PM" : "AM";
    hh = hh % 12;
    if (hh === 0) hh = 12;
    const hhPadded = hh.toString().padStart(2, "0");
    return `${hhPadded}:${mm} ${ampm}`;
  };

  // Convert 12-hour time to 24-hour format
  const formatTo24Hour = (time12) => {
    if (!time12) return "00:00";

    const time = time12.replace(/\s/g, ''); // Remove spaces
    const [timePart, ampm] = time.match(/([0-9]{1,2}:[0-9]{2})(AM|PM)?/i)?.slice(1) || [];

    if (!timePart) return "00:00";

    let [hh, mm] = timePart.split(':');
    hh = parseInt(hh, 10);

    if (ampm) {
      if (ampm.toUpperCase() === 'PM' && hh < 12) hh += 12;
      if (ampm.toUpperCase() === 'AM' && hh === 12) hh = 0;
    }

    return `${hh.toString().padStart(2, '0')}:${mm}`;
  };

  // Generate time options for 12-hour format
  const generateTimeOptions = () => {
    const times = [];

    // AM times
    for (let hour = 1; hour <= 11; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} AM`;
        times.push(timeString);
      }
    }

    // 12 PM
    times.push("12:00 PM");
    times.push("12:30 PM");

    // PM times
    for (let hour = 1; hour <= 11; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} PM`;
        times.push(timeString);
      }
    }

    return times;
  };

  const timeOptions = generateTimeOptions();

  useEffect(() => {
    axios.post(`${API_BASE_URL}working_hrs_list.php`)
      .then((response) => {
        if (response.data.head.code === 200) {
          setWorkingHrsList(response.data.body);
          // setFilteredOrders(response.data.body);
          // console.log(response.data.body[0]);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setWorkingHrsList([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setWorkingHrsList([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });

    axios.post(`${API_BASE_URL}designation_list.php`)
      .then((response) => {
        if (response.data.head.code === 200) {
          setDesignations(response.data.body);
          // setFilteredOrders(response.data.body);
          // console.log(response.data.body[0]);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setDesignations([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setDesignations([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);
  const [workingId, setWorkingId] = useState(null);

  const defaultForm = {
    working_id: workingId,
    from_date: "",
    to_date: "",
    // days: "Mon",
    desig_id: "",
    from_time: "09:00 AM",
    to_time: "05:00 PM",
  };


  const [formData, setFormData] = useState(defaultForm);


  // const daysOptions = ["Monday - Friday", "Saturday"];
  // const designationOptions = ["Staff", "Manager", "Admin"];

  const handleShow = () => {
    setFormData(defaultForm);
    setWorkingId(null);
    setShow(true);
  };

  const handleClose = () => {
    setFormData(defaultForm);
    setWorkingId(null);
    setShow(false);
  };

  const handleSubmit = (e) => {

    e.preventDefault();
    const { from_date, to_date, desig_id, from_time, to_time } = formData;
    console.log("===============", to_time);
    if (!from_date || !to_date || !desig_id || !from_time || !to_time) return;

    if (workingId) {
     
      const data = { working_id: workingId, from_date, to_date, desig_id, from_time, to_time };
      const apiData = {
        ...data,
        from_time: formatTo24Hour(data.from_time),
        to_time: formatTo24Hour(data.to_time)
      };
      axios.post(`${API_BASE_URL}working_hrs_detail_edit.php`,
        apiData
      )
        .then((response) => {
          if (response.data.head.code === 200) {
            window.location.reload();
          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
        }).finally(() => {
        });
    } else {
       console.log("&&&&&&&&&&&&&&&&&&");
      const data = { from_date, to_date, desig_id, from_time, to_time };
      const apiData = {
        ...data,
        from_time: formatTo24Hour(data.from_time),
        to_time: formatTo24Hour(data.to_time)
      };
      axios.post(`${API_BASE_URL}working_hrs_add.php`,
        apiData
      )
        .then((response) => {
          if (response.data.head.code === 200) {
            window.location.reload();
          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
        }).finally(() => {
        });
    }

    handleClose();
  };

  const handleEditItem = (item) => {
    console.log("====item id ====", item.working_id);
      const apiData = item;

      // convert DD-MM-YYYY → YYYY-MM-DD
      const convertToInputDate = (dateStr) => {
        if (!dateStr) return "";
        const [dd, mm, yyyy] = dateStr.split("-");
        return `${yyyy}-${mm}-${dd}`;
      };

      const updatedData = {
        ...apiData,
        working_id: item.working_id,
        desig_id: item.desig_id || defaultForm.desig_id,
        from_date: convertToInputDate(apiData.from_date),
        to_date: convertToInputDate(apiData.to_date),
        from_time: formatTo12Hour(item.from_time),   // ✅ convert to "09:00 AM"
      to_time: formatTo12Hour(item.to_time), 
      };

      setFormData(updatedData);
    // setFormData({
    //   working_id: item.working_id,
    //   // days: item.days || defaultForm.days,
    //   from_date: item.from_date || defaultForm.from_date,
    //   to_date: item.to_date || defaultForm.to_date,
    //   desig_id: item.desig_id || defaultForm.desig_id,
    //   // from_time: item.from_time || defaultForm.from_time,
    //   // to_time: item.to_time || defaultForm.to_time,
    //   from_time: formatTo12Hour(item.from_time),   // ✅ convert to "09:00 AM"
    //   to_time: formatTo12Hour(item.to_time),       // ✅ convert to "05:00 PM"
    // });
    setWorkingId(item.working_id);
    setShow(true);

    console.log("======= time data =========== ", formData.from_time);
  };


  // const handleRemoveItem = (id) => {
  //   setWorkingHrsList(workingHrsList.filter((item) => item.working_id !== id));
  // };

  const handleRemoveItem = (working_id) => {
    // setCustomers(customers.filter((c) => c.user_id !== user_id));
    axios.post(`${API_BASE_URL}working_hrs_delete.php`, { working_id: working_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          // setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);
          window.location.reload();

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          // setCustomers([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // setCustomers([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  };

  return (
    <>
      <Container fluid className="my-4 outer-container">
        <h2 className="text-center">🕒 Working Hours</h2>
        {workingHrsList.length === 0 && (
          <Container fluid className="outer-container my-4">
            <Row>
              <Col>
                <div className="not-found-box">Loading...</div>
              </Col>
            </Row>
          </Container>
        )}
        <Row className="mb-3">
          <Col className="d-flex justify-content-end">
            <Button className="btn-top" onClick={handleShow}>
              <FaPlus /> Add
            </Button>
          </Col>
        </Row>

        <Table bordered responsive className="table-striped my-3 customer-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Date</th>
              <th>Designation</th>
              <th>From</th>
              <th>To</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {workingHrsList.map((item, i) => (
              <tr key={item.working_id}>
                <td>{i + 1}</td>
                <td>{item.from_date} to {item.to_date}</td>
                <td>{item.desig_name}</td>
                <td>{formatTo12Hour(item.from_time)}</td>
                <td>{formatTo12Hour(item.to_time)}</td>
                <td className="">
                  <FaEdit
                    className="edit-icon me-3"
                    onClick={() => handleEditItem(item)}
                    style={{ cursor: "pointer", marginRight: "10px" }}
                  />
                  <FaTrash
                    className="delete-icon"
                    // onClick={() => handleRemoveItem(item.working_id)}
                    onClick={() => {
                      if (window.confirm("Are you sure you want to delete this?")) {
                        handleRemoveItem(item.working_id);
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  />
                </td>
              </tr>
            ))}
            {/* {workingHrsList.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center">
                  No entries
                </td>
              </tr>
            )} */}
          </tbody>
        </Table>
      </Container>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{workingId ? "Edit Working Hours" : "Add Working Hours"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            {/* ⭐ From Date */}
            <Form.Group className="mb-3">
              <Form.Label>From Date</Form.Label>
              <Form.Control
                type="date"
                value={formData.from_date}
                onChange={(e) =>
                  setFormData({ ...formData, from_date: e.target.value })
                }
              />
            </Form.Group>

            {/* ⭐ To Date */}
            <Form.Group className="mb-3">
              <Form.Label>To Date</Form.Label>
              <Form.Control
                type="date"
                value={formData.to_date}
                onChange={(e) =>
                  setFormData({ ...formData, to_date: e.target.value })
                }
              />
            </Form.Group>
            {/* <Form.Group className="mb-3">
              <Form.Label>Days</Form.Label>
              <Form.Select
                value={formData.days}
                onChange={(e) => setFormData({ ...formData, days: e.target.value })}
              >
                {daysOptions.map((d) => (
                  <option key={d} value={d}>
                    {d}
                  </option>
                ))}
              </Form.Select>
            </Form.Group> */}

            <Form.Group className="mb-3">
              <Form.Label>Designation</Form.Label>
              <Form.Select
                value={formData.desig_id}
                onChange={(e) =>
                  setFormData({ ...formData, desig_id: e.target.value })
                }
              >
                {designations.map((designation) => (
                  <option key={designation.desig_id} value={designation.desig_id}>
                    {designation.desig_name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Row className="mb-3">
              <Col>
                <Form.Group>
                  <Form.Label>From Time</Form.Label>
                  <Form.Select
                    value={formData.from_time}
                    onChange={(e) => setFormData({ ...formData, from_time: e.target.value })}
                  // disabled={loading}
                  >
                    {timeOptions.map((time) => (
                      <option key={time} value={time}>
                        {time}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>To Time</Form.Label>
                  <Form.Select
                    value={formData.to_time}
                    onChange={(e) => setFormData({ ...formData, to_time: e.target.value })}
                  // disabled={loading}
                  >
                    {timeOptions.map((time) => (
                      <option key={time} value={time}>
                        {time}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-end">
              <Button onClick={handleClose} className="me-2 btn-top">
                Cancel
              </Button>
              <Button type="submit" className="btn-submit btn">
                {workingId ? "Update" : "Submit"}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default WorkingHours;
